import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ModalService {
  private modals: any[] = [];

  constructor() { }

  add(modal: any) {
    // add modal to array of active modals
    this.modals.push(modal);
  }

  remove(id: string) {
    // remove modal from array of active modals
    this.modals = this.modals.filter(function(mod) {
      return mod.id !== id;
    });
  }

  open(id: string) {
    // open modal specified by id
    const matches = this.modals.filter(function(mod) {
      return mod.id === id;
    });
    if (matches.length > 0) {
      document.body.style.overflowY = 'hidden';
      matches[0].show();
    }
    return false;
  }

  close(id: string) {
    // close modal specified by id
    const matches = this.modals.filter(function(mod) {
      return mod.id === id;
    });
    if (matches.length > 0) {
      document.body.style.overflowY = 'auto';
      matches[0].hide();
    }
    return false;
  }
}
